var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0B966B",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h15v3H.5zM13.5 5.5v8h-11v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.5h5v3h-5z"
  }))));
}
export default SvgIconPackage;